<template>
  <div id="app" :class="currentClass">
    <transition-group name="fade">

      <div class="wrap" v-show="startedQuiz === false" key="intro" >
        <div class="intro">
          
          <div class="intro-inner">
            <h1>Preparing Solutions</h1>
            <p>Complete the quiz to practice preparing solutions of different concentrations.</p>
            <button class="btn" v-on:click="beginQuiz">Begin</button>
          </div>

        </div>
      </div>

      <quiz v-bind:questions="questions" v-on:restartQuiz="resetQuiz" v-show="startedQuiz === true" key="quizComponent"></quiz>

    </transition-group>
  </div>
</template>

<script>
import Quiz from './components/Quiz.vue'

export default {
  name: 'app',
  components: {
    Quiz
  },
  methods: {
    beginQuiz: function () {
      this.startedQuiz = true;
      this.currentClass = 'quizGo';
    },
    resetQuiz: function () {
      this.startedQuiz = false;
      this.currentClass = '';
    }
  },
  data: function () {
    return {
      startedQuiz: false,
      currentClass: '',
      questions: [
        { //1 
          question: 'What size volumetric flask would you use to create <strong>1.50 M</strong> solution using <strong>43.85 g</strong> of <strong>NaCl</strong>?',
          choices: {
            A: '100 ml',
            B: '250 ml',
            C: '500 ml',
            D: '1000 ml'
          },
          answer: 'C',
          solutionVolume: '500 ml',
          solutionChemical: 'NaCl',
          solutionChemicalImage: 'NaCl',
          solutionMeasure: '43.85 g',
          formulaImage: 'formulas_nacl-01'
        },
        { //2 
          question: 'What is the concentration of a <strong>NaCl</strong> solution if <strong>86.00 g</strong> of solute was dissolved in enough water to form <strong>1000. ml</strong> of solution?',
          choices: {
            A: '0.08600 M',
            B: '1.472 M',
            C: '0.6795 M',
            D: '2.356 M'
          },
          answer: 'B',
          solutionVolume: '1000 ml',
          solutionChemical: 'NaCl',
          solutionChemicalImage: 'NaCl',
          solutionMeasure: '86.00 g',
          formulaImage: 'formulas_nacl-02'
        },
        { //3
          question: 'Determine the mass of <strong>NaCl</strong> needed to create a <strong>500. ml</strong> solution with a concentration of <strong>1.50 M</strong>.',
          choices: {
            A: '43.8 g',
            B: '0.750 g',
            C: '32.2 g',
            D: '58.44 g'
          },
          answer: 'A',
          solutionVolume: '500 ml',
          solutionChemical: 'NaCl',
          solutionChemicalImage: 'NaCl',
          solutionMeasure: '43.8 g',
          formulaImage: 'formulas_nacl-03'
        },
        { //4
          question: 'What size volumetric flask would you use to create a <strong>0.50 M</strong> solution using <strong>10.00 g</strong> of <strong>CaBr<sub>2</sub></strong>?',
          choices: {
            A: '100 ml',
            B: '250 ml',
            C: '500 ml',
            D: '1000 ml'
          },
          answer: 'A',
          solutionVolume: '100 ml',
          solutionChemical: 'CaBr<sub>2</sub>',
          solutionChemicalImage: 'CaBr',
          solutionMeasure: '10.00 g',
          formulaImage: 'formulas_cabr-01'
        },
        { //5
          question: 'What is the concentration of a <strong>CaBr<sub>2</sub></strong> solution if <strong>125.00 g</strong> of solute was dissolved in enough water to form <strong>250. ml</strong> of solution?',
          choices: {
            A: '0.500 M',
            B: '2.50 M',
            C: '0.799 M',
            D: '6.40 M'
          },
          answer: 'B',
          solutionVolume: '250 ml',
          solutionChemical: 'CaBr<sub>2</sub>',
          solutionChemicalImage: 'CaBr',
          solutionMeasure: '125.00 g',
          formulaImage: 'formulas_cabr-02'
        },
        { //6
          question: 'Determine the mass of <strong>CaBr<sub>2</sub></strong> needed to create a <strong>500. ml</strong> solution with a concentration of <strong>1.15 M</strong>.',
          choices: {
            A: '99.9 g',
            B: '115 g',
            C: '575 g',
            D: '57.5 g'
          },
          answer: 'B',
          solutionVolume: '500 ml',
          solutionChemical: 'CaBr<sub>2</sub>',
          solutionChemicalImage: 'CaBr',
          solutionMeasure: '115 g',
          formulaImage: 'formulas_cabr-03'
        },
        // { //7
        //   question: 'What size volumetric flask would you use to create a <strong>0.25 M</strong> solution using <strong>7.47 g</strong> of <strong>Li<sub>2</sub>O</strong>?',
        //   choices: {
        //     A: '100 ml',
        //     B: '250 ml',
        //     C: '500 ml',
        //     D: '1000 ml'
        //   },
        //   answer: 'D',
        //   solutionVolume: '1000 ml',
        //   solutionChemical: 'Li<sub>2</sub>O',
        //   solutionChemicalImage: 'LiO',
        //   solutionMeasure: '7.47 g',
        //   formulaImage: 'formulas_lio-01'
        // },
        // { //8
        //   question: 'What is the concentration of a <strong>Li<sub>2</sub>O</strong> solution if <strong>7.10 g</strong> of solute was dissolved in enough water to form <strong>500. ml</strong> of solution?',
        //   choices: {
        //     A: '14.2 M',
        //     B: '0.0598 M',
        //     C: '1.55 M',
        //     D: '.476 M'
        //   },
        //   answer: 'D',
        //   solutionVolume: '500 ml',
        //   solutionChemical: 'Li<sub>2</sub>O',
        //   solutionChemicalImage: 'LiO',
        //   solutionMeasure: '7.10 g',
        //   formulaImage: 'formulas_lio-02'
        // },
        // { //9
        //   question: 'Determine the mass of <strong>Li<sub>2</sub>O</strong> needed to create a <strong>1000. ml</strong> solution with a concentration of <strong>2.00 M.</strong>',
        //   choices: {
        //     A: '2.00 g',
        //     B: '24.3 g',
        //     C: '14.9 g',
        //     D: '59.8 g'
        //   },
        //   answer: 'D',
        //   solutionVolume: '1000 ml',
        //   solutionChemical: 'Li<sub>2</sub>O',
        //   solutionChemicalImage: 'LiO',
        //   solutionMeasure: '59.8 g',
        //   formulaImage: 'formulas_lio-03'
        // },
        { //10
          question: 'What size volumetric flask would you use to create a <strong>1.25 M</strong> solution using <strong>29.75 g</strong> of <strong>MgCl<sub>2</sub></strong>?',
          choices: {
            A: '100 ml',
            B: '250 ml',
            C: '500 ml',
            D: '1000 ml'
          },
          answer: 'B',
          solutionVolume: '250 ml',
          solutionChemical: 'MgCl<sub>2</sub>',
          solutionChemicalImage: 'MgCl',
          solutionMeasure: '29.75 g',
          formulaImage: 'formulas_mgcl-01'
        },
        { //11
          question: 'What is the concentration of a <strong>MgCl<sub>2</sub></strong> solution if <strong>23.80 g</strong> of solute was dissolved in enough water to form <strong>500. ml</strong> of solution?',
          choices: {
            A: '0.500 M',
            B: '0.250 M',
            C: '0.0486 M',
            D: '0.190 M'
          },
          answer: 'A',
          solutionVolume: '500 ml',
          solutionChemical: 'MgCl<sub>2</sub>',
          solutionChemicalImage: 'MgCl',
          solutionMeasure: '23.80 g',
          formulaImage: 'formulas_mgcl-02'
        },
        { //12
          question: 'Determine the mass of <strong>MgCl<sub>2</sub></strong> needed to create a <strong>100. ml</strong> solution with a concentration of <strong>3.00 M</strong>.',
          choices: {
            A: '300 g',
            B: '0.317 g',
            C: '28.6 g',
            D: '17.93 g'
          },
          answer: 'C',
          solutionVolume: '100 ml',
          solutionChemical: 'MgCl<sub>2</sub>',
          solutionChemicalImage: 'MgCl',
          solutionMeasure: '28.6 g',
          formulaImage: 'formulas_mgcl-03'
        },
        { //13
          question: 'What size volumetric flask would you use to create a <strong>1.00 M</strong> solution using <strong>166.00 g</strong> of <strong>KI</strong>?',
          choices: {
            A: '100 ml',
            B: '250 ml',
            C: '500 ml',
            D: '1000 ml'
          },
          answer: 'D',
          solutionVolume: '1000 ml',
          solutionChemical: 'KI',
          solutionChemicalImage: 'KI',
          solutionMeasure: '166.00 g',
          formulaImage: 'formulas_ki-01'
        },
        { //14
          question: 'What is the concentration of a <strong>KI</strong> solution if <strong>20.68 g</strong> of solute was dissolved in enough water to form <strong>100. ml</strong> of solution?',
          choices: {
            A: '1.25 M',
            B: '0.125 M',
            C: '0.207 M',
            D: '1.75 M'
          },
          answer: 'A',
          solutionVolume: '100 ml',
          solutionChemical: 'KI',
          solutionChemicalImage: 'KI',
          solutionMeasure: '20.68 g',
          formulaImage: 'formulas_ki-02'
        },
        { //15
          question: 'Determine the mass of <strong>KI</strong> needed to create a <strong>250. ml</strong> solution with a concentration of <strong>2.25 M</strong>.',
          choices: {
            A: '562.50 g',
            B: '41.50 g',
            C: '165.98 g',
            D: '93.5 g'
          },
          answer: 'D',
          solutionVolume: '250 ml',
          solutionChemical: 'KI',
          solutionChemicalImage: 'KI',
          solutionMeasure: '93.5 g',
          formulaImage: 'formulas_ki-03'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
@import "assets/styles.scss";
#app {
  padding: 0 5px;
}
.quizGo {
  background: #fff;
  min-height: 100vh;
}
.intro, {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  h1, p { 
    color: $grey; 
    margin: 0 auto 2.5rem;
    line-height: 1.5;
  }
  h1 {
    font: bold 2rem $font-family;
    letter-spacing: 0.1rem;
  }
  h2 {
    text-align: left;
    font: bold 18px $font-family;
    letter-spacing: 0.15rem;
    color: #888;
    text-transform: uppercase;
  }
  p { font-size: 1.5rem; }
  p br { display: none; }
  .intro-inner { position: relative; max-width: 40rem; }

}
@media screen and (min-width: 600px) {
  .intro p br { display: block; }
}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}
.fade-enter-active {
  transition-delay: 0.35s;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
.btn {
  border: solid 1px $blue;
  background: $blue;
  color: #fff;
  padding: 0.6rem 2.2rem;
  text-transform: uppercase;
  font: bold 1rem $font-family;
  letter-spacing: 0.16rem;
  cursor: pointer;
  &.alt {
    border: solid 1px $blue;
    background: none;
    color: $blue;
  }
}
p { 
  margin: 0 0 20px;
}

</style>